<template>
  <div class="leftarea-outter">
    <div>
        <border style="width: 500px;height: 290px;">
            <template v-slot:title>
                <customTitle text="近7日用户增长/活跃统计" />
            </template>
            <template v-slot:tabledata>
                <line1 />
            </template>
        </border>
    </div>
    <div>
        <border style="width: 500px;height: 290px;">
            <template v-slot:title>
                <customTitle text="近7日用户学习/实训统计" />
            </template>
            <template v-slot:tabledata>
                <line2 />
            </template>
        </border>
    </div>
  </div>
</template>

<script>
import border from '@/components/main/components/border.vue'
import customTitle from '@/components/main/components/title.vue'
import line2 from './left-components/line2.vue'
import line1 from './left-components/line1.vue'
export default {
    components: {
        border,
        customTitle,
        line2,
        line1
    }
}
</script>

<style scoped>
.leftarea-outter {
    width: 500px;
    height: 600px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}
</style>